import React from 'react';
import { Link } from 'react-router-dom';
import {
  BsClipboardCheck,
  BsThermometerHalf,
  BsExclamationCircle,
  BsStars,
  BsShieldX,
  BsSliders
} from 'react-icons/bs';

export default function QuickReports() {
  const reports = [
    {
      id: 1,
      label: 'Daily Compliance Report',
      to: '/compliance-center',
      icon: <BsClipboardCheck />
    },
    {
      id: 2,
      label: 'Temperature Report',
      to: '/temperature',
      icon: <BsThermometerHalf />
    },
    {
      id: 3,
      label: 'Incident Report',
      to: '/incident',
      icon: <BsExclamationCircle />
    },
    {
      id: 4,
      label: 'Cleaning Report',
      to: '/compliance-center/checks/cleaning-check',
      icon: <BsStars />
    },
    {
      id: 5,
      label: 'Allergen Report',
      to: '/compliance-center/checks/allergen-check',
      icon: <BsShieldX />
    },
    {
      id: 6,
      label: 'Custom Report',
      to: '/compliance-center',
      icon: <BsSliders />
    }
  ];

  return (
    <div className="w-full bg-white border border-slate-100 rounded-2xl p-5 shadow-sm font-sans text-slate-800">

      {/* SECTION TITLE */}
      <h2 className="text-xs font-bold text-slate-900 mb-3.5 tracking-wide uppercase">
        Quick Reports
      </h2>

      {/* REPORT GRID */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {reports.map((report) => (
          <Link
            key={report.id}
            to={report.to}
            className="flex items-center gap-2.5 bg-white border border-slate-100 hover:border-slate-200 px-4 py-3 rounded-xl text-left text-xs font-semibold text-slate-700 shadow-[0_1px_3px_rgba(0,0,0,0.02)] hover:bg-slate-50 transition-all active:scale-[0.98]"
          >
            <div className="text-blue-600 text-sm shrink-0">
              {report.icon}
            </div>

            <span className="truncate leading-tight">
              {report.label}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
